import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import UserManagementPageWorking from './UserManagementPageWorking';
import { HostAnalyticsPage } from './HostAnalyticsPage';
import { UserTrustSafetyPage } from './UserTrustSafetyPage';

// 🎭 NEW: Unified User Hub
import { UserHub } from './UserHub';

// 🎯 NEW: Customer-facing components  
import { UserDashboard } from '../user/UserDashboard';

export const UsersPage: React.FC = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="hub" replace />} />
      
      {/* 🏠 NEW: Unified User Hub - replaces scattered management pages */}
      <Route path="hub" element={<UserHub />} />
      
      {/* 🎯 NEW: Customer Dashboard - for end users */}
      <Route path="dashboard" element={<UserDashboard />} />
      
      {/* 🔧 LEGACY: Keep existing routes for backward compatibility */}
      <Route path="management" element={<UserManagementPageWorking />} />
      <Route path="analytics" element={<HostAnalyticsPage />} />
      <Route path="trust-safety" element={<UserTrustSafetyPage />} />
    </Routes>
  );
};